"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H2 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.H2 = styled_components_1.default.h2 `
  font-size: 22px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 5px;

  text-align: left;
`;
//# sourceMappingURL=h2.js.map